var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M25.3187 7.42203V24.378C25.3187 25.1624 24.682 25.7991 23.8976 25.7991C23.1132 25.7991 22.4766 25.1624 22.4766 24.378V7.42203C22.4766 6.63761 23.1132 6.00098 23.8976 6.00098C24.682 6.00098 25.3187 6.63761 25.3187 7.42203",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9374_32925",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 22,
    width: 22,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 22.957H34.7928V40.836H13V22.957Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9374_32925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7934 24.3781C34.7934 24.6433 34.7195 24.9048 34.5755 25.136L25.0999 40.1726C24.8384 40.5857 24.3856 40.8377 23.8967 40.8377C23.4079 40.8377 22.955 40.5857 22.6936 40.1726L13.218 25.136C12.9433 24.6983 12.9262 24.145 13.1782 23.6922C13.4283 23.2375 13.9039 22.957 14.4212 22.957H33.3723C33.8896 22.957 34.3652 23.2375 34.6153 23.6922C34.7346 23.9063 34.7934 24.1431 34.7934 24.3781",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.78b88cef3442b99e9c6be9afead4c3eb.svg";
export { ForwardRef as ReactComponent };